import { Button } from '@/components/ui/button.js';
import { SessionStatusChangeModal } from './session-status-change-modal.js';
import { AdminSession, SessionStatus } from '@airreading/common/data';

interface SessionCancelButtonProps {
  session: AdminSession;
  trigger?: React.ReactNode;
}

export const SessionCancelButton = ({ session, trigger }: SessionCancelButtonProps) => {
  if (session.status === SessionStatus.cancelled) {
    return null;
  }

  return (
    <SessionStatusChangeModal
      sessions={[session]}
      trigger={
        trigger || (
          <Button variant="outline" className="bg-slate-100 hover:bg-slate-200">
            Cancel session
          </Button>
        )
      }
      targetStatus={SessionStatus.cancelled}
      modalTitle="Cancel Session"
      noValidSessionsTitle="Cancel Session"
      confirmBtnLabel="Cancel session"
      description="Are you sure you want to cancel this session? This action will cancel all student attendance and send a cancellation email to the teacher."
      noValidSessionsMessage="This session cannot be canceled."
      invalidSessionsMessage="This session cannot be canceled."
      buttonVariant="destructive"
    />
  );
};
